import { gql } from '@apollo/client';

export const GET_CALENDAR_EVENTS = gql`
  query CalendarEvents($query: CalendarEventsFilter) {
    calendarEvents(query: $query) {
      data {
        id
        start
        end
        type
        title
        color
        extendedProps
      }
    }
  }
`;
